module.exports = __webpack_public_path__ + "img/YourSchoolLogo.0c6bc822.png";